/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './TextInput.scss'
import React from 'react'
import r from '../../../util/Renderer'

/*
props {
  label
  caution
  type
  name
  value
  placeholder
  onChange
  state
}
*/

function TextInput(props) {
  const state = props.state || ''
  const option = props.option || ''
  const caution = props.caution || ''
  const className = props.className || ''
  const disabled = props.disabled || false
  const value = props.value || ''

  return (
    <div className={`textInput ${className}`}>
      {r.renderIf(props.label)(
        <div className={`textInput__label textInput__label-${state} textInput__label-${option}`}>
          {props.label} <div className="textInput__optionIcon" />
          {r.renderIf(caution)(<div className="textInput__caution">{caution}</div>)}
        </div>
      )}

      <input
        className={`textInput__text textInput__text-${state}`}
        type={props.type}
        name={props.name}
        value={value}
        placeholder={props.placeholder}
        onChange={props.onChange}
        onKeyUp={props.onKeyUp}
        disabled={disabled}
      />
    </div>
  )
}

export default TextInput
